import { StackLayout } from '@leagueplatform/genesis-core';
import { Masonry } from '@leagueplatform/masonry';

export const CustomerSupportMasonrySection = () => (
  <StackLayout
    orientation="vertical"
    css={{
      maxWidth: '706px',
      marginBottom: '$two',
    }}
  >
    <Masonry rootNodeId="customer-support$root" />
  </StackLayout>
);
